<template>
  <div class="upload-item">
    <div class="upload-contianer m-upload-contianer" :style="{'width': limit == 1 ? '7.5rem' : '16.7rem', 'justifyContent': limit == 1 ? 'start' : 'space-between'}">
      <template v-if="getFileList&&getFileList.length > 0">
        <template v-if="isMobile">
          <!-- :style="{'width': this.getFileList.length <= 1 ? '7.5rem' : '16.7rem', 'justifyContent': limit == 1 ? 'start' : 'space-between'}" -->
          <div class="img-box img-box-m"
            
            v-for="(item, index) in getFileList"
            :key="index">
              <van-image
                width="7.5rem"
                height="7.5rem"
                radius=".8rem"
                fit="cover"
                :src="item.url"
                @click="toPreviewImg(item)"></van-image>
              <div class="shadow">
                <span class="iconfont icon-delete" @click="toDelete(index)"></span>
              </div>
          </div>
        </template>
        <template v-else>
          <!-- :style="{'width': this.getFileList.length <= 1 ? '7.5rem' : '16.7rem', 'justifyContent': limit == 1 ? 'start' : 'space-between'}" -->
          <div class="img-box img-box-m"
            v-for="(item, index) in getFileList"
            :key="index">
              <el-image
                style="width: 7.5rem; height: 7.5rem"
                fit="cover"
                :src="item.url"
                @click="toPreviewImg(item)"></el-image>
              <div class="shadow">
                <span class="iconfont icon-delete" @click="toDelete(index)"></span>
              </div>
          </div>
        </template>
      </template>
      <div class="upload-box" :class="{hide: getFileList.length >= this.limit}" @click="onUploadImage" v-if="isInNative">
        <span class="iconfont icon-add"></span>
        <span class="txt">{{name}}</span>
      </div>
      <van-uploader v-else
        :class="{hide: getFileList.length >= this.limit}" 
        :before-read="beforeRead"
        :after-read="afterRead"
        :max-count="limit"
        :accept="'image/*'"
        :disabled="disabled"
      >
        <span class="iconfont icon-add"></span>
        <span class="txt">{{name}}</span>
      </van-uploader>
    </div>
    <!-- pc端 -->
    <div class="upload-contianer pc-upload-contianer" :style="{'justifyContent': limit == 1 ? 'start' : 'space-between'}">
      <template v-if="getFileList&&getFileList.length > 0">
        <template v-if="isMobile">
          <!-- :style="{'width': this.getFileList.length <= 1 ? '7.5rem' : '16.7rem', 'justifyContent': limit == 1 ? 'start' : 'space-between'}" -->
          <div class="img-box img-box-pc"
            v-for="(item, index) in getFileList"
            :key="index">
              <van-image
                width="150px"
                height="150px"
                radius="8px"
                fit="cover"
                :src="item.url"
                @click="toPreviewImg(item)"></van-image>
              <span class="iconfont icon-delete" @click="toDelete(index)"></span>
          </div>
        </template>
        <template v-else>
          <!-- :style="{'width': this.getFileList.length <= 1 ? '7.5rem' : '16.7rem', 'justifyContent': limit == 1 ? 'start' : 'space-between'}" -->
          <div class="img-box img-box-pc" 
            v-for="(item, index) in getFileList"
            :key="index">
              <el-image
                style="width: 150px; height: 150px"
                fit="cover"
                :src="item.url"
                @click="toPreviewImg(item)"></el-image>
              <div class="shadow">
                <span class="iconfont icon-delete" @click="toDelete(index)"></span>
              </div>
          </div>
        </template>
      </template>
      <div class="upload-box" :class="{hide: getFileList.length >= this.limit}" @click="onUploadImage" v-if="isInNative">
        <span class="iconfont icon-add"></span>
        <span class="txt">{{name}}</span>
      </div>
      <van-uploader v-else
        :class="{hide: getFileList&&getFileList.length >= this.limit}" 
        :before-read="beforeRead"
        :after-read="afterRead"
        :max-count="limit"
        :accept="'image/*'"
        :disabled="disabled"
      >
        <span class="iconfont icon-add"></span>
        <span class="txt">{{name}}</span>
      </van-uploader>
    </div>

    <!-- pc端预览图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
    >
      <img
        :src="previewUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog> 
  </div>
</template>
<script>
import { uploadIcpMedia } from '@/api/register';
import { Uploader, ImagePreview } from "vant";
import { imgPreview } from "@/utils/imgPreview.js";
import { Bridge } from '@/utils/bridge';
import { AppUtils } from '@/utils/bridge';

export default {
  name: "uploadImg",
  components: {
    [Uploader.name]: Uploader
  },
  props: {
    type: {
      type: Number,
      default: null
    },
    shopCode: {
      type: String,
      default: ''
    },
    orderField: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 1
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: String,
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 大小限制 10M (MB)
    fileSize: {
      type: Number,
      default: 5 * 1024 * 1024,
    }
  },
  data() {
    return {
      isInNative: Bridge.isInNative(),
      isMobile: false,
      dialogVisible: false,
      // preImgArr: [],
      fileList: this.value,
      previewUrl: ''
    };
  },
  model: {
    prop: "value",
    event: "valChange"
  },
  computed: {
    // 图片数组数据
    getFileList: {
      get () {
        return this.value||[]
      },
      set (val) {
        this.$emit('valChange', val||[])
      }
    },
    // 控制达到最大限制时隐藏上传按钮
    isMaxHidden () {
      return this.getFileList.length >= this.limit
    }
    
  },
  created() {
    this.fetchData();
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
  },
  methods: {
    fetchData() {},
    beforeRead(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some(type => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }
      if (!isImg) {
        this.Toast(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
        // this.Toast(
        //   `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
        // );
        return false;
      }
      // if (this.fileSize) {
      //   const isLt = file.size / 1024 / 1024 < this.fileSize / 1024 / 1024;
      //   if (!isLt) {
      //     this.Toast(`上传头像图片大小不能超过 ${this.fileSize/ 1024 / 1024} MB!`);
      //     return false;
      //   }
      // }
      return true;
    },
    // 上传图片
    afterRead(file) {
      imgPreview(file.file, async (files) => {
        if (this.fileSize) {
          const isLt = files.size / 1024 / 1024 < this.fileSize / 1024 / 1024;
          if (!isLt) {
            this.Toast(`上传头像图片大小不能超过 ${this.fileSize/ 1024 / 1024} MB!`);
            return false;
          }
        }
        let fileUrl = files;
        let formData = new FormData();
        formData.append("type", this.type);
        formData.append("shopCode", this.shopCode);
        formData.append("orderField", this.orderField);
        formData.append("file", fileUrl);
        uploadIcpMedia(formData).then(res => {
          this.getFileList.push({url:res.data.url,media_id:res.data.media_id})
          this.$emit('valChange', this.getFileList)
        });
      })
    },
    onUploadImage() {
      if (Bridge.isInNative()) {
        AppUtils.uploadImage(this.limit, (imageUrls) => {
          if (this.fileList) {
            let arr = this.fileList.split(",");
            imageUrls.forEach(item=>{
              arr.push(item);
            })
            this.fileList = arr;
            this.getFileList = arr;
            this.fileList = arr.join(",");
            return false;
          } else {
            let arr = [];
            imageUrls.forEach(item=>{
              arr.push(item);
            })
            this.getFileList = arr;
            this.fileList = arr.join(",");
          }
        })
      }
    },
    // 文件过大
    // oversize(e) {
    //   this.Toast("图片过大！");
    // },
    // 预览图片
    toPreviewImg(data) {
      let arr = [];
      arr.push(data.url);
      if(this.isMobile) {
        ImagePreview({
          images: arr,
          closeable: true,
          closeOnPopstate: true,
          showIndicators: true,
          loop: true
        });
      } else {
        this.dialogVisible = true;
        this.previewUrl = data.url;
      }
    },
    // 删除图片
    toDelete(index) {
      this.getFileList.splice(index,1);
      this.$forceUpdate();
      this.$emit('valChange', this.getFileList)
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-btns{
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-box{
  background: #F5F5F7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
@media screen and (max-width:750px){

  .upload-box{
    width: 7.5rem;
    height: 7.5rem;
    border-radius: .8rem;
  }
  /deep/ .van-uploader{
    width: 7.5rem;
    height: 7.5rem;
  }
  /deep/ .van-uploader__wrapper{
    width: 7.5rem;
    height: 7.5rem;
    @include flex();
    flex-direction: column;
    background: #F5F5F7;
    border-radius: .8rem;
  }
  /deep/ .van-uploader__input-wrapper{
    width: 7.5rem;
    height: 7.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  /deep/ .van-uploader__preview, /deep/ .van-uploader__preview{
    margin: 0;
  }
  /deep/ .van-image{
    width: 7.5rem;
    height: 7.5rem;
  }
  .upload-item{
    width: 7.5rem;
    min-height: 7.5rem;
    // background: #F5F5F7;
    // border-radius: .8rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .upload-contianer{
      min-height: 7.5rem;
      display: flex;
      flex-wrap: wrap;
      background: #fff;
      /deep/ .van-uploader__wrapper{
        width: 7.5rem;
        height: 7.5rem;
      }
    }
    .img-box{
      // width: 7.5rem;
      min-height: 7.5rem;
      display: flex;
      position: relative;
      margin-bottom: .5rem;
      /deep/ .el-image{
        border-radius: .5rem;
      }
      .shadow {
        width: 1.4rem;
        height: 1.4rem;
        position: absolute;
        top: 0;
        right: 0;
        background-color: rgba(0,0,0,.5);
        opacity: 1;
        transition: opacity .3s;
        color: #fff;
        font-size: 1rem;
        padding: .1rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .icon-add{
      font-size: 1.2rem;
      color: $base-color;
    }
    .icon-delete-a, .icon-delete{
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.4rem;
    }
    .txt{
      display: inline-block;
      font-size: .7rem;
      color: #999;
      margin-top: .3rem;
    }
  }
  .m-upload-contianer{
    display: flex !important;
  }
  .pc-upload-contianer{
    display: none !important;
  }
}
@media screen and (min-width:750px){
  .upload-box{
    width: 150px;
    height: 150px;
    border-radius: 16px;
    cursor: pointer;
  }
  /deep/ .van-uploader{
    width: 150px;
    height: 150px;
  }
  /deep/ .van-uploader__wrapper{
    width: 150px;
    height: 150px;
    @include flex();
    flex-direction: column;
    background: #F5F5F7;
    border-radius: 16px;
  }
  /deep/ .van-uploader__input-wrapper{
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  /deep/ .van-uploader__preview, /deep/ .van-uploader__preview{
    margin: 0;
  }
  /deep/ .van-image{
    width: 150px;
    height: 150px;
  }
  .upload-item{
    // width: 150px;
    // min-height: 150px;
    // background: #F5F5F7;
    // border-radius: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .upload-contianer{
      min-height: 150px;
      display: flex;
      flex-wrap: wrap;
      background: #fff;
      /deep/ .van-uploader__wrapper{
        width: 150px;
        height: 150px;
      }
    }
    .img-box{
      // width: 150px;
      // min-height: 150px;
      // display: flex;
      position: relative;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      display: inline-block;
      /deep/ .el-image{
        border-radius: 10px;
      }
      .shadow {
        width: 28px;
        height: 28px;
        position: absolute;
        top: 0;
        right: 0;
        background-color: rgba(0,0,0,.5);
        opacity: 1;
        transition: opacity .3s;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .icon-add{
      font-size: 24px;
      color: $base-color;
    }
    .icon-delete-a, .icon-delete{
      position: absolute;
      top: 0;
      right: 0;
      font-size: 28px;
    }
    .txt{
      display: inline-block;
      font-size: 14px;
      color: #999;
      margin-top: 6px;
    }
  }
  .m-upload-contianer{
    display: none !important;
  }
  .pc-upload-contianer{
    // width: 150px;
    display: flex !important;
  }
}

// .img-list{
//   img{
//     width: 7.5rem;
//     height: 7.5rem;
//     border-radius: .8rem;
//   }
//   .img-box{
//     width: 7.5rem;
//     height: 7.5rem;
//     position: relative;
//     .iconfont{
//       font-size: 1.4rem;
//       color: #222;
//       position: absolute;
//       right: .1rem;
//       top: .1rem;
//       z-index: 2;
//     }
//   }
// }
.hide{
  display: none;
}
.img-box{
  background: #F5F5F7;
}
.img-box-m{
  height: 7.5rem;
  border-radius: .8rem;
  /deep/ .el-image__inner{
    border-radius: .8rem;
  }
}

.img-box-pc{
  height: 150px;
  border-radius: 16px;
  /deep/ .el-image__inner{
    border-radius: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VantMediaUploadImg.vue